import SlideShowSlideSdk from '../components/SlideShowSlide/corvid/SlideShowSlide.corvid';


const SlideShowSlide = {
  sdk: SlideShowSlideSdk
};


export const components = {
  ['SlideShowSlide']: SlideShowSlide
};

